import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { SITE_URL, SITE_BRAND } from "@/lib/seo-config";
import { BLOG_POSTS_LIST } from "@/lib/blog-posts";
import { ArrowRight, Clock, Tag } from "lucide-react";

const seoConfig = {
  title: "Blog Batisur · Guides pratiques BTP, prix, aides, sécurité travaux",
  description: "Le blog de référence pour vos travaux BTP en 2026 : arnaques à éviter, prix rénovation, aides MaPrimeRénov', Factur-X, DPE, séquestre Stripe. Guides écrits par des experts terrain.",
  keywords: "blog BTP France, guide travaux 2026, arnaque artisan, prix rénovation, MaPrimeRénov, Factur-X 2026, DPE loi climat, séquestre Stripe travaux, artisan de confiance",
  canonical: "/blog",
  ogType: "website",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": `Blog ${SITE_BRAND}`,
      "url": `${SITE_URL}/blog`,
      "description": "Guides pratiques BTP, prix, aides, réglementation par Batisur Connect.",
      "publisher": { "@type": "Organization", "name": SITE_BRAND, "url": SITE_URL },
      "blogPost": BLOG_POSTS_LIST.map((p) => ({
        "@type": "BlogPosting",
        "headline": p.title,
        "url": `${SITE_URL}/blog/${p.slug}`,
        "datePublished": p.date,
        "author": { "@type": "Organization", "name": p.author },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Accueil", "item": SITE_URL },
        { "@type": "ListItem", "position": 2, "name": "Blog", "item": `${SITE_URL}/blog` },
      ],
    },
  ],
};

export default function BlogIndex() {
  return (
    <div className="min-h-screen bg-[#F7F7F9]" data-testid="blog-index-page">
      <SEO cfg={seoConfig} />
      <Navbar />

      <section className="bg-[#0A0A0B] text-white border-b-2 border-[#0A0A0B] relative overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-10 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20 relative">
          <div className="mono text-[11px] uppercase tracking-widest text-[#FF4D00] font-semibold">// Blog Batisur</div>
          <h1 className="display text-4xl lg:text-6xl tracking-tighter mt-3 max-w-4xl leading-[0.95]">
            Guides pratiques pour <span className="text-[#FF4D00]">vos travaux BTP</span> en 2026
          </h1>
          <p className="mt-6 text-zinc-300 text-base lg:text-lg max-w-3xl">
            Arnaques à éviter, prix moyens 2026, aides MaPrimeRénov', obligations Factur-X et DPE, méthodes de sécurisation.
            Des articles écrits par notre équipe terrain — pas de blabla, que du concret utilisable.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS_LIST.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-card-${post.slug}`}
              className="group border-2 border-[#0A0A0B] bg-white p-6 shadow-[4px_4px_0_#0A0A0B] hover:shadow-[6px_8px_0_#FF4D00] hover:-translate-y-1 transition"
            >
              <div className="flex items-center gap-2 mono text-[10px] uppercase tracking-widest">
                <span className="text-[#FF4D00] font-semibold">// {post.category}</span>
                <span className="text-zinc-400">·</span>
                <span className="text-zinc-500 flex items-center gap-1"><Clock className="w-3 h-3" /> {post.readTime} min</span>
              </div>
              <h2 className="display text-xl mt-3 leading-tight group-hover:text-[#FF4D00] transition">
                {post.title}
              </h2>
              <p className="mt-3 text-sm text-zinc-600 line-clamp-3">{post.excerpt}</p>
              <div className="mt-5 flex items-center justify-between border-t border-zinc-200 pt-4">
                <div className="mono text-[10px] uppercase tracking-widest text-zinc-500">
                  {new Date(post.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                </div>
                <ArrowRight className="w-4 h-4 text-[#FF4D00] group-hover:translate-x-1 transition" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
